import { Util } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';

const isEmailValid = (email)=>email && Util.validations.isEmailAddress(email)
;
const isPostalCodeValid = (country, postalCode)=>country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode)
;
const useValidatePaymentData = ()=>{
    const { getLabel  } = useIntl();
    return (intermediatePaymentData)=>{
        var ref;
        const { shippingAddress , paymentMethodData , email  } = intermediatePaymentData;
        const billingAddress = (ref = paymentMethodData.info) === null || ref === void 0 ? void 0 : ref.billingAddress;
        if (!isEmailValid(email)) {
            return {
                isPaymentDataValid: false,
                error: {
                    reason: 'SHIPPING_ADDRESS_INVALID',
                    message: getLabel('checkout.contact.email.errorMessage'),
                    intent: 'SHIPPING_ADDRESS'
                }
            };
        }
        if (!isPostalCodeValid(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.countryCode, billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode)) {
            return {
                isPaymentDataValid: false,
                error: {
                    reason: 'SHIPPING_ADDRESS_INVALID',
                    message: getLabel('checkout.address.postalCode.errorMessage'),
                    intent: 'SHIPPING_ADDRESS'
                }
            };
        }
        if (shippingAddress && !isPostalCodeValid(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.countryCode, shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postalCode)) {
            return {
                isPaymentDataValid: false,
                error: {
                    reason: 'SHIPPING_ADDRESS_INVALID',
                    message: getLabel('checkout.address.postalCode.errorMessage'),
                    intent: 'SHIPPING_ADDRESS'
                }
            };
        }
        if (!(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.locality)) {
            return {
                isPaymentDataValid: false,
                error: {
                    reason: 'SHIPPING_ADDRESS_INVALID',
                    message: getLabel('checkout.address.city.errorMessage'),
                    intent: 'SHIPPING_ADDRESS'
                }
            };
        }
        return {
            isPaymentDataValid: true
        };
    };
};

export { useValidatePaymentData };
//# sourceMappingURL=use-validate-payment-data.js.map
